import type { FC, ReactElement } from 'react';

import { L10nText } from '../../../../services/uiTranslations/reactBindings/L10nText';

import styles from './AutoplayBetInfo.module.css';

export interface AutoplayBetInfoProps {
  totalBet: ReactElement;
}

export const AutoplayBetInfo: FC<AutoplayBetInfoProps> = ({ totalBet }) => {
  return (
    <>
      <L10nText tk="BET_PER_ROUND" />:<span className={styles.totalBet}>{totalBet}</span>
    </>
  );
};
